<ion-content class="theme-{{userService.theme}}">
    <ion-header [ngClass]="{'veeam': this.theme === 'veeam'}">
        <app-header [backRoute]="['/home']"></app-header>
    </ion-header>
<div class="social-wrap page-width-and-shadow">

    <div class="title content-wrap" [@enter]>
        <div class="text my-color-blue">{{'__TASKS_TASKS__' | translate}}</div>
        <app-inline-svg class="icon" [file]="'assets/img/footer/group.svg'"></app-inline-svg>
    </div>

    <div class="switch-line content-wrap" [@enter]>
        <div class="text">{{'__TASKS_TASKS_TO_BE_COMPLETED__' | translate}}</div>
        <div class="switch">
            <span>{{'__TASKS_HIDE_COMPLETED__' | translate}}</span>
            <ion-toggle [(ngModel)]="isHideCompleted" class="My-toggle" mode="md"></ion-toggle>
        </div>
    </div>

    <div class="list content-wrap" *ngIf="this.tasksList !== null">
        <div *ngFor="let item of (tasksList | tasksPipe : isHideCompleted) ; let i = index" class="line"
             [@leave]>
            <div class="logo"><img src="assets/img/journey/{{item.icon}}.svg" alt="icon" (click)="runTask(item)"></div>
            <div class="text" (click)="runTask(item)" [innerHTML]="item.title | safeHtml"></div>
            <ion-checkbox class="My-checkbox" (click)="changeStatus(item)"
                          [(ngModel)]="item.status" [disabled]="item.section === 'pdr_feedback'"></ion-checkbox>
        </div>
    </div>

    <app-skeleton-tasks class="content-wrap" *ngIf="this.tasksList === null"></app-skeleton-tasks>
</div>
</ion-content>
